export default __webpack_public_path__ + "static/media/loaderLogoS.3bfdfce1.png";